import React from 'react';
import { List, ListItem, ListItemText, makeStyles } from '@material-ui/core';
//import { getDefaultNormalizer } from "@testing-library/dom";

const useStyles = makeStyles((theme) => ({
  subList: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  primaryItemText: {
    fontSize: 12,
    color: '#717271',
    [theme.breakpoints.up('sm')]: {
      fontSize: 14,
    },
  },
  secondaryItemText: {
    overflowWrap: 'break-word',
    fontSize: 16,
    color: '#323232',
    [theme.breakpoints.up('sm')]: {
      fontSize: 20,
    },
  },
}));

export default function ListItems({
  userData,
  carData,
  insuranceName,
  techData,
  taxIVA,
  taxIIBB,
  activityName,
}) {
  const classes = useStyles();
  const { currentAddress } = userData;
  const { userCarInsurance } = carData;

  return (
    <>
      {insuranceName === 'AUTOMOTOR' ? (
        <>
          <List
            component='div'
            disablePadding
            classes={{ root: classes.subList }}
          >
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Año'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={userCarInsurance.carYear}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Marca'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={userCarInsurance.carBrandName}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Modelo'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={userCarInsurance.carModelName}
              />
            </ListItem>
          </List>

          <List
            component='div'
            disablePadding
            classes={{ root: classes.subList }}
          >
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Versión'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={userCarInsurance.carVersionName}
              />
            </ListItem>
          </List>
          <List
            component='div'
            disablePadding
            classes={{ root: classes.subList }}
          >
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='GNC'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={userCarInsurance.carGNC === 'true' ? 'Si' : 'No'}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Valor'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={userCarInsurance.carPriceGNC}
              />
            </ListItem>
          </List>
          <List
            component='div'
            disablePadding
            classes={{ root: classes.subList }}
          >
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Patente'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={userCarInsurance.carPatent}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Chasis'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={userCarInsurance.carChasis}
              />
            </ListItem>
          </List>

          <List
            component='div'
            disablePadding
            classes={{ root: classes.subList }}
          >
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Motor'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={userCarInsurance.carMotor}
              />
            </ListItem>
          </List>
        </>
      ) : (
        <div></div>
      )}

      {(insuranceName === 'HOGAR' ||
        insuranceName === 'INTEGRAL DE COMERCIO' ||
        insuranceName === 'AUTOMOTOR') &&
      currentAddress ? (
        <>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{
                classes: { root: classes.primaryItemText },
              }}
              primary='Nombres y Apellidos'
              secondaryTypographyProps={{
                classes: { root: classes.secondaryItemText },
              }}
              secondary={`${userData.nombre} ${userData.apellido}`}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{
                classes: { root: classes.primaryItemText },
              }}
              primary='Documento'
              secondaryTypographyProps={{
                classes: { root: classes.secondaryItemText },
              }}
              secondary={userData.numeroDocumento}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{
                classes: { root: classes.primaryItemText },
              }}
              primary='Calle'
              secondaryTypographyProps={{
                classes: { root: classes.secondaryItemText },
              }}
              secondary={currentAddress.street}
            />
          </ListItem>
          <List
            component='div'
            disablePadding
            classes={{ root: classes.subList }}
          >
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Número'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={currentAddress.streetNumber}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Piso'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={currentAddress.floor}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Departamento'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={currentAddress.department}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='CP'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={currentAddress.zipCode}
              />
            </ListItem>
          </List>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{
                classes: { root: classes.primaryItemText },
              }}
              primary='Provincia'
              secondaryTypographyProps={{
                classes: { root: classes.secondaryItemText },
              }}
              secondary={currentAddress.state.name}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primaryTypographyProps={{
                classes: { root: classes.primaryItemText },
              }}
              primary='Localidad'
              secondaryTypographyProps={{
                classes: { root: classes.secondaryItemText },
              }}
              secondary={currentAddress.locality}
            />
          </ListItem>
          {insuranceName === 'INTEGRAL DE COMERCIO' ? (
            <>
              <ListItem>
                <ListItemText
                  primaryTypographyProps={{
                    classes: { root: classes.primaryItemText },
                  }}
                  primary='Actividad del comercio'
                  secondaryTypographyProps={{
                    classes: { root: classes.secondaryItemText },
                  }}
                  secondary={activityName.slice(0, -12)}
                />
              </ListItem>
              <List
                component='div'
                disablePadding
                classes={{ root: classes.subList }}
              >
                <ListItem>
                  <ListItemText
                    primaryTypographyProps={{
                      classes: { root: classes.primaryItemText },
                    }}
                    primary='Condición frente al IVA'
                    secondaryTypographyProps={{
                      classes: { root: classes.secondaryItemText },
                    }}
                    secondary={
                      taxIVA === 'MONO'
                        ? 'Régimen Simplificado'
                        : 'Responsable Inscripto'
                    }
                  />
                </ListItem>

                <ListItem>
                  <ListItemText
                    primaryTypographyProps={{
                      classes: { root: classes.primaryItemText },
                    }}
                    primary='Ingresos Brutos IC'
                    secondaryTypographyProps={{
                      classes: { root: classes.secondaryItemText },
                    }}
                    secondary={taxIIBB === 'S' ? 'Si' : 'No'}
                  />
                </ListItem>
              </List>
            </>
          ) : (
            <div></div>
          )}
        </>
      ) : (
        <>
          <List component='div' disablePadding>
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Nombres y Apellidos'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={`${userData.nombre} ${userData.apellido}`}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primaryTypographyProps={{
                  classes: { root: classes.primaryItemText },
                }}
                primary='Documento'
                secondaryTypographyProps={{
                  classes: { root: classes.secondaryItemText },
                }}
                secondary={userData.numeroDocumento}
              />
            </ListItem>
            <ListItem>
              {techData[0] && (
                <ListItemText
                  primaryTypographyProps={{
                    classes: { root: classes.primaryItemText },
                  }}
                  primary='Marca Celular'
                  secondaryTypographyProps={{
                    classes: { root: classes.secondaryItemText },
                  }}
                  secondary={techData[0].value}
                />
              )}
              {techData[1] && (
                <ListItemText
                  primaryTypographyProps={{
                    classes: { root: classes.primaryItemText },
                  }}
                  primary='Modelo Celular'
                  secondaryTypographyProps={{
                    classes: { root: classes.secondaryItemText },
                  }}
                  secondary={techData[1].value}
                />
              )}
            </ListItem>
            <ListItem>
              {techData[2] && (
                <ListItemText
                  primaryTypographyProps={{
                    classes: { root: classes.primaryItemText },
                  }}
                  primary='Marca notebook / tablet'
                  secondaryTypographyProps={{
                    classes: { root: classes.secondaryItemText },
                  }}
                  secondary={techData[3].value}
                />
              )}
              {techData[3] && (
                <ListItemText
                  primaryTypographyProps={{
                    classes: { root: classes.primaryItemText },
                  }}
                  primary='Modelo notebook / tablet'
                  secondaryTypographyProps={{
                    classes: { root: classes.secondaryItemText },
                  }}
                  secondary={techData[2].value}
                />
              )}
            </ListItem>
          </List>
        </>
      )}
    </>
  );
}
